export const getToken = (): string | null => {
    return localStorage.getItem('user.tk');
}

export const removeToken = (): void => {
    localStorage.removeItem('user.tk');
}